import { TMeta } from '@/shared/api';

import { TQuestionnaireProlongations, TQuestionnaireRepayment } from './questionnaires';

export type TOrder = {
    id: number;
    number: string;
    create_date: Date;
    method: string;
    has_insurance: true;
    credit_product_id: number;
    org_id: number;
    rentLeaseInfo: {
        cost: number;
    };
    rentProduct: {
        is_buyout: boolean;
        id: number;
        name: string;
        presentation_photos: null | { id: number; image: string; isMain: boolean }[];
        price: number;
        rent_pledge: {
            apr_amount: string;
        };
        store: {
            address: string;
            id: number;
            name: string;
            coordinatesSalePoint: TCoordinates;
            workTimeSalePoint: string;
        };
    };
    payments_possibilities: {
        repayment: {
            allow: boolean;
            reason: string;
        };
        prolongation: {
            allow: boolean;
            reason: string;
        };
    };
    status: {
        id: number;
        name: string;
        type_id: number;
        time: string;
        color: string;
        type: EOrderStatus[];
    };
    params: {
        amounts: {
            requested: number;
            agreed: number;
            selected: number;
        };
        terms: {
            requested: number;
            agreed: number;
            selected: number;
        };
    };
    amounts: {
        return: {
            current: number;
            total: number;
            interest: number;
        };
        issue: number;
        prolongation: number;
        paymentsSum: number;
        balance: number;
        earlyPartialDebtAmount: number;
        installment_amount: number;
    };
    terms: {
        return_date: string;
        issue_date: string;
        nearest_pay_date: string;
        overdue_days: number;
    };

    documents: [
        {
            id: number;
            state: string;
        },
    ];
    repayments: TQuestionnaireRepayment[];
    jurist: {
        executor: null | OrderOfficerLawModel;
        debt: number;
    };
    prolongations: TQuestionnaireProlongations[];
    product?: TOrderProduct;
};

type TOrderProduct = {
    product_class_id: number;
    product_type: string;
    classifier_name: string;
    classifier_group: string;
    term_unit: 1 | 2;
};

export type TOrderWithMeta = {
    data: TOrder[];
    meta: TMeta;
};

export type OrderOfficerLawModel = {
    name: string;
    address: string;
    phones: string;
    type: string;
};

export type OrderPriceModel = {
    rent: number;
    pledge: number;
};

export type OrderDateRentModel = {
    start: Date | string;
    return: Date | string;
};

export enum EOrderStatus {
    Approved = 'approved',
    Delayed = 'delayed',
    Issued = 'issued',
    Prolonged = 'prolonged',
    Sent_to_court = 'sent_to_court',
    Closed = 'closed',
    Active = 'active',
    All = 'all',
    Rejected = 'rejected',
}

export type OrderModel = {
    id: number;
    title: string;
    slug: string;
    image: string;
    status: EOrderStatus;
    prices?: OrderPriceModel;
    contractName: string;
    dateRent?: OrderDateRentModel;
    daysLeft?: number;
    daysOverdue?: number;
    priceOverdue?: number;
    issuingAddress: string;
    workingHours: string;
    officerLaw?: OrderOfficerLawModel;
};
